import { LICENSE_PLATE_REGEX, VIN_REGEX } from '../constants/regex';

export interface OcrScannerConfig {
   charWhitelist: string;
   charBlacklist: string;
   maxAttempts?: number;
   scanInterval?: number;
   imageProcessing?: {
      contrast?: number;
      brightness?: number;
      grayscale?: boolean;
      blur?: number;
   };
   patterns?: {
      vin?: RegExp;
      license?: RegExp;
   };
}

/**
 * Default configuration preset for OCR Scanner
 * 
 * @remarks
 * Optimized for Polish vehicle identification patterns
 * under typical.
 * 
 * @example
 * // Import with custom overrides
 * const config = {
 *   ...DEFAULT_OCR_CONFIG,
 *   maxAttempts: 3
 * };
 */
export const DEFAULT_OCR_CONFIG: OcrScannerConfig = {
   charWhitelist: 'ABCDEFGHJKLMNPRSTUVWXYZ0123456789',
   charBlacklist: '|\\/[]{}()<>~`@#$%^&*_+=;:"\',.?~!',
   maxAttempts: 5,
   scanInterval: 1500,
   imageProcessing: {
      contrast: 120,
      brightness: 110,
      grayscale: true,
   },
   patterns: {
      vin: VIN_REGEX,
      license: LICENSE_PLATE_REGEX
   }
};